module.exports = __webpack_public_path__ + "static/fonction4-82c3f090f503612a10e654e4de5210f6.jpg";